
{
  "title": "关于 WhatsGood HK",
  "subtitle": "您在香港寻找可靠本地服务的信赖指南",
  "mission": {
    "title": "我们的使命",
    "description": "WhatsGood HK 创建的目的是为了缩短外籍人士与香港值得信赖的本地服务提供者之间的距离。我们了解在新城市寻找可靠服务的挑战，特别是当语言障碍和对本地企业的不熟悉让整个过程变得困难重重时。"
  },
  "whatWeOffer": {
    "title": "我们提供什么",
    "verified": {
      "title": "经过验证的服务提供者",
      "description": "想要安心吗？选择带有验证徽章的提供者 - 这些档案包含额外的检查和功能。"
    },
    "directContact": {
      "title": "直接联系",
      "description": "通过 WhatsApp 直接与提供者联系 - 无需中间人，无额外费用。"
    },
    "reviews": {
      "title": "社区评论",
      "description": "来自真实客户的真实评论帮助您做出明智的决定。"
    }
  },
  "whyChoose": {
    "title": "为什么选择 WhatsGood HK？",
    "local": {
      "title": "贴心且本地化",
      "description": "我们的平台专为香港量身定制，提供者熟悉本地需求、期望和工作方式。"
    },
    "expat": {
      "title": "外籍人士友好",
      "description": "我们的平台是为外籍人士设计的，让您更容易找到会说英语的服务提供者。"
    },
    "transparent": {
      "title": "透明",
      "description": "无隐藏费用，无佣金收费 - 只是您与服务提供者之间的直接连接。"
    }
  }
}
